import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';
import {
  setAddedDevices,
  setRemovedDevices
} from '#action/project/devices-popup';
import { AddDevicesButton as StyledAddDevicesButton, AddButtonLabel } from '#component/device/devices-popup/styles';

const AddDevicesButton = props => {
  const dispatch = useDispatch();
  const {
    selected,
    setSelected,
    selectedAlert,
    setSelectedAlert,
    project,
    addMode,
    data,
    alertId,
    fetchDevices,
    setFormDevices,
    formDevices: propsFormDevices
  } = props;
  const {
    newlyAddedDevices,
    removedDevices
  } = useSelector(s => s.projectDevicesPopup, shallowEqual);
  // Devices are supplied by the RHF-based cargo form
  const cargoDevices = propsFormDevices ?? data?.formDevices ?? [];

  const handleAddFormDevices = async () => {
    const newDevicesData = [
      ...cargoDevices,
      ...selected
    ];

    const newGroup = {
      ...data,
      formDevices: newDevicesData,
      applianceGroup: {
        ...data?.applianceGroup,
        devices: newDevicesData
      }
    };

    if (alertId) {
      setSelectedAlert([...selectedAlert, ...selected]);
    }

    const selectedIds = selected.map(s => s.id);
    const newRemovedDevices = removedDevices.filter(d => !selectedIds.includes(d.id));

    await dispatch(setRemovedDevices(newRemovedDevices));
    await dispatch(setAddedDevices([...newlyAddedDevices, ...selected]));

    setFormDevices?.(newDevicesData);

    await dispatch(fetchDevices(project?.id, addMode, true, newGroup));

    if (newDevicesData.length < 11 && addMode) {
      setFormDevices?.(newDevicesData);
    }

    setSelected([]);
  };

  return (
    <StyledAddDevicesButton
      size="small"
      color="secondary"
      aria-label="Add devices"
      onClick={handleAddFormDevices}
    >
      <AddIcon />
      <AddButtonLabel>{`Add selected (${selected?.length})`}</AddButtonLabel>
    </StyledAddDevicesButton>
  );
};

export default AddDevicesButton;
